<template>
  <div id="outerEST">
     <div class="left-menu">
        <div class="logo-img-div">
            <img src="../../assets/logo.png" alt="" class="logo">
        </div>
        <div>
          <div class="pageOptions">
            <el-menu
                  :default-active="id"
                  class="el-menu-vertical-demo">
                <el-menu-item :index="item.id" @click="navClick(item)" v-for="(item,i) in navList" :key="i">
                  <span slot="title">{{item.title}}</span>
                </el-menu-item>
            </el-menu>
          </div>
        </div>
     </div>
        <biaoshi v-if="id==1 || id==7" :type="Number(id)" :newdate="newdate" />
        <gaoxiao v-if="id==2 || id==3 || id==4 || id==5 || id==9 || id==17 || id==15" :id="Number(id)" :type="returnTitle('type')" :title="returnTitle('title')" />
        <qianVue v-if="id==6" />
        <pingguVue v-if="id==11" />
        <seatVue v-if="id==12" />
        <piciVue v-if="id==13" />
        <zhengjiVue v-if="id==14" />
        <tianbaoVue v-if="id==16" />
      </div>
  </div>
</template>

<script>
import gaoxiao from "./components/gaoxiao.vue";
import biaoshi from "./components/biaoshi.vue"
import qianVue from "./components/qian.vue"
import pingguVue from "./components/pinggu.vue"
import seatVue from "./components/seat.vue"
import piciVue from "./components/pici.vue"
import zhengjiVue from "./components/zhengji.vue"
import tianbaoVue from "./components/tianbao.vue"
export default {
  components: {
    gaoxiao,biaoshi,qianVue,pingguVue,seatVue,piciVue,
    zhengjiVue,tianbaoVue
  },
  data() {
    return {
      id: "1",
      newdate:"",
      navList: [
        { id: "1", title: "学校标识码", isRou: false },
        { id: "2", title: "学校保研率", isRou: true ,type:'3',url: "/School?n=baoyan"},
        { id: "3", title: "全国高校名单", isRou: true,type:'1',url: "/School" },
        { id: "4", title: "大学排行", isRou: true,type:'4',url: "/School?n=paihang" },
        { id: "5", title: "具有研究生推免权学校",isRou:true,type:'5',url: "/School?n=tuimian" },
        { id: "6", title: "世界前1000名大学",isRou:false },
        { id: "7", title: "军校查询",isRou:false },
        { id: "8", title: "招生简章", isRou: true, url: "/School?n=zhaosheng" },
        { id: "9", title: "双一流学科查询",isRou:true,type:'11',url: "/School?n=shuangyiliu" },
        { id: "17", title: "国家级特色专业",isRou:true,type:'6',url: "/School?n=tesezhuanye" },
        { id: "10", title: "查询专业", isRou: true, url: "/Major" },
        { id: "11", title: "学科评估",isRou:false},
        { id: "12", title: "查位次",isRou:false },
        { id: "13", title: "批次线查询",isRou:false },
        { id: "14", title: "往年征集",isRou:false },
        { id:"19",title:"招生计划",isRou:true,url:"/RecruitData"},
        { id: "15", title: "中外合作院校",isRou:true,type:'9',url: "/School?n=zhongwai" },
        { id: "16", title: "填报与录取时间",isRou:false },
      ],
    };
  },
  mounted() {
    this.$nextTick(()=>{
      if(this.$route.query.n){
        this.id = this.$route.query.n
      }
    })
  },
  methods: {
    navClick(item) {
      if (item.isRou == false) {
        this.id = item.id;
        this.newdate = String(new Date().getTime())
      } else {
        this.id = this.id
        const routerUrl = this.$router.resolve({
          path: item.url,
        });
        window.open(routerUrl.href, "_blank");
      }
    },
    returnTitle(name){
      let a = this.navList.find(r=>r.id==this.id);
      return a[name];
    },
  },
};
</script>

<style lang="scss" scoped>
@import './scss/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/comprehensive/index.vue